import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { AdminsContainer } from 'src/features/administrators/tenant/containers/admins';
import { meilisearchSearchSchema } from 'src/hooks/meilisearch/schema/meilisearch-search-schema';

export const Route = createFileRoute(
  '/_layout/tenant/organization-details/_layout/admins',
)({
  component: AdminsContainer,
  validateSearch: zodValidator(meilisearchSearchSchema),
});
